import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async cancelarFechamentoPedido(axios, parametros) {
    parametros.operacao = 'cancelarFechamentoPedido';

    let retorno = {};

    await axios.santriPOST('/rest/orcamento', parametros, 20, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },
  
}


// WEBPACK FOOTER //
// ./src/components/Rest/ROrcamento/ROrcamentoCancelarFechamentoPedido.js